var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 5.16699H8.66671V6.50033H11.3334C12.4334 6.50033 13.3334 7.40033 13.3334 8.50033C13.3334 9.60033 12.4334 10.5003 11.3334 10.5003H8.66671V11.8337H11.3334C13.1734 11.8337 14.6667 10.3403 14.6667 8.50033C14.6667 6.66033 13.1734 5.16699 11.3334 5.16699ZM7.33337 10.5003H4.66671C3.56671 10.5003 2.66671 9.60033 2.66671 8.50033C2.66671 7.40033 3.56671 6.50033 4.66671 6.50033H7.33337V5.16699H4.66671C2.82671 5.16699 1.33337 6.66033 1.33337 8.50033C1.33337 10.3403 2.82671 11.8337 4.66671 11.8337H7.33337V10.5003ZM5.33337 7.83366H10.6667V9.16699H5.33337V7.83366Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkFilterIcon);
export default __webpack_public_path__ + "static/media/link_filter_icon.49816ae10c217daf54f2bc75e73510e1.svg";
export { ForwardRef as ReactComponent };